import { ToastContainer } from "react-toastify";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import AllPages from "./Pages/AllPages";
import "react-toastify/dist/ReactToastify.css";
import { InvoiceProvider } from "./InvoiceContext/InvoiceContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
const queryClient = new QueryClient();
function App() {
  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <InvoiceProvider>
          <Navbar />
          <AllPages />
          <Footer />
          <ToastContainer autoClose={1000}></ToastContainer>
        </InvoiceProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
